import * as React from 'react';
// import styles from './index.less';
import styles from './index.less';
import img_banner from './assets/banner@2x.png';
import img_officer from './assets/officer@2x.png';
import img_invite from './assets/invite@2x.png';
import img_cash from './assets/cash.png';
import img_new from './assets/new.png';
import img_redpacket from './assets/redpacket.png';
import { FUtil, FI18n } from '@freelog/tools-lib';
import FFooter from '@/components/Footer';
import { ActivityDetailsPageModelState } from '@/models/activityDetailsPage';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import FComponentsLib from '@freelog/components-lib';

interface PlayNewerProps {
  activityDetailsPage: ActivityDetailsPageModelState;
}

function PlayNewer({ activityDetailsPage }: PlayNewerProps) {
  const scrollToAnchor = (anchorName: any) => {
    let state: any = {
      behavior: 'smooth',
      block: 'start',
    };
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView(state);
      }
    }
  };
  return (
    <>
      <div
        // className={'play-newer w-100x h-100x flex-column align-center'}
        className={styles.playNewer}
        style={{
          width: '100vw',
          // height: '100vh',
          display: 'flex',
          flexFlow: 'column',
          position: 'relative',
          alignItems: 'center',
        }}
      >
        <div
          // className='red-pack flex-row align-center p-15'
          className={styles.redPack}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
            zIndex: 100,
          }}
          onClick={() => scrollToAnchor('inner-test')}
        >
          <div
            // className='h-40 over-h packet'
            className={styles.packet}
            style={{
              height: '40px',
              overflow: 'hidden',
            }}
          >
            <img
              src={img_redpacket}
              alt=''
              // className='h-100x'
              style={{
                height: '100%',
              }}
            />
          </div>
          <div
            // className='h-24 over-h ml-14 flex-row'
            style={{
              height: '24px',
              overflow: 'hidden',
              marginLeft: '14px',
              display: 'flex',
              position: 'relative',
            }}
          >
            <div className={styles.cash} />
            <img
              src={img_cash}
              alt=''
              //  className='h-100x'
              style={{ height: '100%' }}
            />
          </div>
        </div>
        <img src={img_banner} alt='' style={{ height: 650 }} />
        <div
          id='inner-test'
          //  className='h-60 push-test w-100x'
          className={styles.pushTest}
          style={{
            height: 60,
            width: '100%',
          }}
        />
        <div
          // className='w-100x test-wrap'
          className={styles.testWrap}
          style={{
            zIndex: 20,
            width: '100%',
          }}
        >
          <div
            // className=' flex-column align-center py-60 pl-190 pr-160 test'
            className={styles.test}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '60px 160px',
            }}
          >
            <div
              // className='flex-row space-between w-100x'
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <div
                // className='flex-column'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 5 }}>
                  <FComponentsLib.FTitleText text={'一、解锁体验官积分玩法，'} type={'h1'} />
                  <label style={{ fontSize: 34, color: '#E9A923', fontWeight: 600, lineHeight: 1 }}>
                    ¥2000
                  </label>
                  <FComponentsLib.FTitleText text={'现金大奖等你拿'} type={'h1'} />
                </div>
                <div style={{ height: 30 }} />
                <FComponentsLib.FContentText
                  text={'活动时间'}
                  type={'normal'}
                  style={{ opacity: 0.4 }}
                />
                <div style={{ height: 15 }} />
                <FComponentsLib.FContentText
                  text={
                    (activityDetailsPage.startTime?.format('YYYY/MM/DD') || 'YYYY/MM/DD') +
                    '～' +
                    (activityDetailsPage.endTime?.format('YYYY/MM/DD') || 'YYYY/MM/DD')
                  }
                  type={'highlight'}
                />
                <div style={{ height: 30 }} />
                <FComponentsLib.FContentText
                  text={'活动内容'}
                  type={'normal'}
                  style={{ opacity: 0.4 }}
                />
                <div style={{ height: 15 }} />

                <FComponentsLib.FContentText
                  text={' 1. 填写招募问卷，获内测体验官资格，首批体验官名额仅限200名，先到先得！'}
                  type={'highlight'}
                />
                <div style={{ height: 15 }} />
                <FComponentsLib.FContentText
                  text={' 2. 3步玩转体验官积分，获得体验官专属福利，更有机会赢取现金大奖。'}
                  type={'highlight'}
                />
                <div style={{ height: 30 }} />
                <FComponentsLib.FContentText
                  text={'现金大奖'}
                  type={'normal'}
                  style={{ opacity: 0.4 }}
                />
                <div style={{ height: 15 }} />

                <div className={styles.row}>
                  <div className={[styles.GoldSilverCopper, styles.gold].join(' ')}>金牌体验官</div>
                  <div style={{ width: 120 }}>
                    <FComponentsLib.FContentText text={'金牌体验官 1名'} type={'highlight'} />
                  </div>
                  <FComponentsLib.FContentText text={'奖励¥2000'} type={'highlight'} />
                </div>

                <div style={{ height: 15 }} />

                <div className={styles.row}>
                  <div className={[styles.GoldSilverCopper, styles.silver].join(' ')}>
                    金牌体验官
                  </div>
                  <div style={{ width: 120 }}>
                    <FComponentsLib.FContentText text={'银牌体验官 2名'} type={'highlight'} />
                  </div>
                  <FComponentsLib.FContentText text={'奖励¥1000'} type={'highlight'} />
                </div>

                <div style={{ height: 15 }} />

                <div className={styles.row}>
                  <div className={[styles.GoldSilverCopper, styles.copper].join(' ')}>
                    金牌体验官
                  </div>
                  <div style={{ width: 120 }}>
                    <FComponentsLib.FContentText text={'铜牌体验官 5名'} type={'highlight'} />
                  </div>
                  <FComponentsLib.FContentText text={'奖励¥500'} type={'highlight'} />
                </div>

                <div style={{ height: 15 }} />

                <div className={styles.row}>
                  <div
                    style={{
                      width: 70,
                      height: 22,
                      padding: '0 5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FIcons.FPentacle style={{ fontSize: 12, color: '#E9A923' }} />
                    <FComponentsLib.FIcons.FPentacle style={{ fontSize: 12, color: '#E9A923' }} />
                    <FComponentsLib.FIcons.FPentacle style={{ fontSize: 12, color: '#E9A923' }} />
                  </div>
                  <div style={{ width: 120 }}>
                    <FComponentsLib.FContentText text={'幸运体验官 20名'} type={'highlight'} />
                  </div>
                  <FComponentsLib.FContentText text={'奖励¥100'} type={'highlight'} />
                </div>
                <div style={{ height: 40 }} />
                <a
                  href={FI18n.i18nNext.tAuto('event_beta_tester_link')}
                  target={'_blank'}
                  className={styles.link}
                >
                  <i>👉</i>
                  <span> 快快戳我了解详情参与活动吧！</span>
                </a>
              </div>
              <div
                //  className='flex-column align-center'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <div style={{ height: 500, display: 'flex', alignItems: 'center' }}>
                  <img src={img_officer} alt='' style={{ height: 360 }} />
                </div>
              </div>
            </div>
            <div
              // className='flex-row space-between w-100x align-center mb-30 mt-75'
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
                margin: '75px 0 30px',
              }}
            >
              <div
                // className='h-360 over-h'
                style={{
                  height: 360,
                  overflow: 'hidden',
                }}
              >
                <img src={img_new} alt='' style={{ height: '100%' }} />
              </div>
              <div
                // className='flex-column align-center w-600 mr-30'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginRight: '30px',
                  width: '600px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 5 }}>
                  <FComponentsLib.FTitleText text={'二、完成新手任务，领'} type={'h1'} />
                  <label style={{ fontSize: 34, color: '#E9A923', fontWeight: 600, lineHeight: 1 }}>
                    ¥20
                  </label>
                  <FComponentsLib.FTitleText text={'现金'} type={'h1'} />
                </div>
                <div style={{ height: 40 }} />
                <FComponentsLib.FContentText
                  text={
                    '完成萌新任务中的【基础任务】、【资源任务】、【节点任务】不仅可以快速了解“如何创建发行资源、如何通过Freelog对资源进行推广变现”，还能领取20元现金奖励！'
                  }
                  type={'highlight'}
                  style={{ textAlign: 'center' }}
                />
                <div style={{ height: 35 }} />

                <a
                  target={'_blank'}
                  href={FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.dashboard()}
                  className={styles.link}
                >
                  <i>👉</i>
                  <span> 完成全部任务仅需9分钟，快戳我领现金奖励吧！</span>
                </a>
              </div>
            </div>
            <div
              // className='flex-row space-between w-100x align-center mb-30 '
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
                margin: '30px 0',
              }}
            >
              <div
                // className='w-600 ml-30'
                style={{
                  width: '600px',
                  marginLeft: '30px',
                }}
              >
                <FComponentsLib.FTitleText
                  text={'三、邀请好友参与内测，赢取额外现金奖励'}
                  type={'h1'}
                />
                <div style={{ height: 10 }} />
                <FComponentsLib.FContentText
                  text={'成功邀请好友成为Freelog内测体验官，即有机会获得最高120元奖励'}
                  type={'additional2'}
                  style={{ fontSize: 14 }}
                />
                <div style={{ height: 30 }} />
                <FComponentsLib.FContentText
                  text={
                    '1、邀请1名好友奖励现金3元，邀请2名好友奖励6元，邀请3名好友奖励10元，邀请4名好友奖励14元，邀请5名好友奖励20元；'
                  }
                  type={'highlight'}
                />
                <div style={{ height: 30 }} />
                <FComponentsLib.FContentText
                  text={'2、成功邀请好友成为体验官的用户，平台也将额外抽取5位，赠送100元京东购物卡'}
                  type={'highlight'}
                />
                <div style={{ height: 30 }} />

                <a
                  href={FI18n.i18nNext.tAuto('beta_event_guideline_referral_link')}
                  target={'_blank'}
                  className={styles.link}
                >
                  <i>👉</i>
                  <span> 立即邀请好友</span>
                </a>
              </div>
              <div
                // className='h-360 over-h'
                style={{
                  height: 360,
                  overflow: 'hidden',
                }}
              >
                <img src={img_invite} alt='' style={{ width: 420 }} />
              </div>
            </div>
          </div>
        </div>
        <FFooter />
      </div>
    </>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(PlayNewer);
